<template>
<div v-if="isShow" class="invoice bg_white">
  <Loading v-show="loading" />
  <div class="invoice_wrap mt24 pl16 pr16">
    <GetInvoiceNumber
      v-if="!isRegister"
      :invoiceNumber="invoiceNumber"
      @editInvoiceNumber="editInvoiceNumber"
      @deleteInvoiceNumber="deleteInvoiceNumber"
    />
    <UpdateInvoiceNumber
      v-if="isRegister"
      :invoiceNumber="invoiceNumber"
      @updateInvoiceNumber="updateInvoiceNumber"
      @update:inputInvoiceNumber="handleInvoiceNumberUpdate"
    />
    <div v-if="actionCompleteInfo" class="invoice_complete mt24">
      <p class="invoice_complete_title ab success">{{ completeTitle }}</p>
      <p class="invoice_complete_sub ab mt16">{{ completeSubTitle }}</p>
      <dl class="invoice_complete_dates mt16">
        <div class="invoice_complete_row">
          <dt class="invoice_complete_label ar">ボーナス締日(予定) :</dt>
          <dd class="invoice_complete_value ab">{{ actionCompleteInfo.bonusCalcCutoffDate }}</dd>
        </div>
        <div class="invoice_complete_row mt8">
          <dt class="invoice_complete_label ar">ボーナス振込日(予定) :</dt>
          <dd class="invoice_complete_value ab">{{ actionCompleteInfo.bonusTransferDate }}</dd>
        </div>
      </dl>
    </div>
    <div class="error ab mt24">{{ errorDescription }}</div>
  </div>
</div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Check from '@/model/getToken';
import Invoice from '@/components/api/invoice/invoice';
import Loading from '@/components/common/Loading';
import GetInvoiceNumber from '@/components/member/invoice/GetInvoiceNumber';
import UpdateInvoiceNumber from '@/components/member/invoice/UpdateInvoiceNumber';

export default {
  components: {
    Loading,
    GetInvoiceNumber,
    UpdateInvoiceNumber
  },
  data() {
    return {
      isShow: true,
      loading: false,
      invoiceNumber: '',
      isRegister: false, // インボイス入力時はtrue
      errorDescription: '',
      actionCompleteInfo: null,
    }
  },
  computed: {
    completeTitle() {
      if (!this.actionCompleteInfo) return '';
      return this.actionCompleteInfo.type === 'register'
        ? 'インボイス登録番号の登録が完了しました。'
        : 'インボイス登録番号の削除が完了しました。';
    },
    completeSubTitle() {
      if (!this.actionCompleteInfo) return '';
      return this.actionCompleteInfo.type === 'register'
        ? '＜ボーナスの特別控除が停止するボーナス計算＞'
        : '＜ボーナスの特別控除が開始されるボーナス計算＞';
    },
  },
  methods: {
    formatBonusDate(dateStr) {
      if (!dateStr) return '';
      const parts = dateStr.split('/');
      if (parts.length !== 3) return `${dateStr}〜`;
      const year = parts[0];
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);
      return `${year}年${month}月${day}日〜`;
    },
    editInvoiceNumber() {
      this.actionCompleteInfo = null;
      this.isRegister = true;
    },
    handleInvoiceNumberUpdate(newInvoiceNumber) {
      this.invoiceNumber = newInvoiceNumber;
    },
    updateInvoiceNumber() {
      this.apiUpdateInvoiceNumber(this.invoiceNumber);
    },
    deleteInvoiceNumber() {
      this.apiDeleteInvoiceNumber();
    },
    async apiGetInvoiceNumber() {
      await Invoice.getInvoiceNumber().then((val) => {
        console.log(val.invoiceNumber);
        this.invoiceNumber = (val.invoiceNumber || '').replace('T', '');
      });
    },
    async apiUpdateInvoiceNumber(invoiceNumber) {
      this.loading = true;
      this.errorDescription = '';
      this.actionCompleteInfo = null;
      await Invoice.updateInvoiceNumber("T"+invoiceNumber).then(async (val) => {
        console.log(val);
        this.loading = false;
        if (!val || val.resultStatus !== 'OK') {
          this.errorDescription = (val && val.errorDescription) ? val.errorDescription : '登録に失敗しました。';
          return;
        }
        this.isRegister = false;
        this.errorDescription = '';
        await this.apiGetInvoiceNumber();
        this.actionCompleteInfo = {
          type: 'register',
          bonusCalcCutoffDate: this.formatBonusDate(val.bonusCalcCutoffDate),
          bonusTransferDate: this.formatBonusDate(val.bonusTransferDate),
        };
      });
    },
    async apiDeleteInvoiceNumber() {
      this.loading = true;
      this.errorDescription = '';
      this.actionCompleteInfo = null;
      await Invoice.deleteInvoiceNumber().then(async (val) => {
        console.log(val);
        this.loading = false;
        if (!val || val.resultStatus !== 'OK') {
          this.errorDescription = (val && val.errorDescription) ? val.errorDescription : '削除に失敗しました。';
          return;
        }
        this.isRegister = false;
        this.errorDescription = '';
        await this.apiGetInvoiceNumber();
        this.actionCompleteInfo = {
          type: 'delete',
          bonusCalcCutoffDate: this.formatBonusDate(val.bonusCalcCutoffDate),
          bonusTransferDate: this.formatBonusDate(val.bonusTransferDate),
        };
      });
    },
    initialized() {
      this.loading = false;
      this.invoiceNumber = '';
      this.isRegister = false;
      this.errorDescription = '';
      this.actionCompleteInfo = null;
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.initialized();
      this.apiGetInvoiceNumber();
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.color_red, .error {
  color: #FF3A3A;
}
.invoice_complete {
  font-size: 14px;
  line-height: 1.6;
}

.success {
  background-color: #e8f5e9;
  border-radius: 6px;
  color: #1b5e20;
  font-size: 14px;
  line-height: 1.5;
  padding: 12px 14px;
}

.invoice_complete_title {
  font-size: 14px;
  margin: 0;
}

.invoice_complete_sub {
  font-size: 14px;
}

.invoice_complete_dates {
  margin: 0;
}

.invoice_complete_row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
}

.invoice_complete_label {
  color: #5a5a5a;
  font-size: 14px;
}

.invoice_complete_value {
  font-size: 14px;
  padding: 2px 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/member/invoice/InvoiceNumber.vue